import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLTextField, PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllQRCodesTable from './Table';
import NewQRCodeModal from '../../Modals/QRCode/NewQRCodeModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllQRCodesView extends Component {
    
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            newModal: false,
            qrCodes: [],
            searchValue: '',
        };

        this.qrCodeQueryObject = {
            sort: 'id,name',
            search: undefined,
            page: 1,
            limit: 10,
        };
    }

    componentDidMount() {
        this.loadQRCodes();
    }

    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.qrCodeQueryObject.search = this.state.searchValue || undefined;
            this.qrCodeQueryObject.page = 1;
            this.setState( {
                fetching: true,
                brands: [],
            } );
            this.loadQRCodes();
        }
    }

    onColumnSort = ( value ) => {
        if( this.qrCodeQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.qrCodeQueryObject.sort = value;
        this.qrCodeQueryObject.page = 1;
        this.setState( {
            fetching: true,
            qrCodes: [],
        } );
        this.loadQRCodes();
    }

    loadQRCodes= () => {
        return this.props.getQRCodes( this.qrCodeQueryObject )
        .then( ( qrcodes ) => {
            this.qrCodeQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.qrCodes = prevState.qrCodes.concat( qrcodes );
                return prevState;
            } );
            return qrcodes;
        } );
    }

    qrCodeUpdated = ( index, qrcode ) => {
        this.setState( ( altState ) => {
            if( qrcode !== null ) {
                altState.qrCodes[ index ] = qrcode;
            } else {
                altState.qrCodes.splice( index, 1 );
            }
            altState.qrCodes = altState.qrCodes.slice( 0 );
            return altState;
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }

    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }

    onNewModalSubmit = ( newQRCode ) => {
        this.setState( ( altState ) => {
            altState.qrCodes.unshift( newQRCode );
            altState.qrCodes = altState.qrCodes.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, qrCodes, searchValue } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>QR Codes</h2>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                        <PrimaryButton
                        label='+ Create QR Code'
                        style={ { width: '200px' } }
                        onClick={ this.openNewModal } />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/qr_codes' className={ style.tabOption }
                        data-active={ true }>Dynamic QR Codes</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allQR }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllQRCodesTable
                            qrCodes={ qrCodes }
                            loadMore={ this.loadQRCodes }
                            currentSort={ this.qrCodeQueryObject.sort }
                            onColumnSort={ this.onColumnSort }
                            onQRCodeUpdated={ this.qrCodeUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewQRCodeModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getQRCodes: ( queryObject ) => {
            return dAPI.get( '/admin/qr_codes', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllQRCodesView );
